
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3b57943f&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MemberCollection.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MemberCollection.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3b57943f!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MemberCollection.vue"),
  /* scopeId */
  "data-v-3b57943f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Collection/MemberCollection.vue
// module id = 694
// module chunks = 0